import axios from 'axios';

import { configureAuthInterceptor } from './configureAuthInterceptor';

export const axiosApiForLogin = axios.create({
  baseURL: process.env.REACT_APP_API,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

// The login page must not hard-redirect when no authenticated session exists.
configureAuthInterceptor(axiosApiForLogin, { redirectOnFailure: false });
